import { Link } from 'react-router-dom';
import { useSiteImage } from '../lib/useSiteImage';

const COMING_SOON_FALLBACK = 'https://images.pexels.com/photos/13802704/pexels-photo-13802704.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900';

export default function ComingSoon({ title = 'Coming Soon', subtitle, eyebrow = 'In Production', imageKey }) {
  const img = useSiteImage(imageKey || '__none__', COMING_SOON_FALLBACK);
  return (
    <div data-testid="coming-soon-page" className="bg-white min-h-screen flex items-center">
      <div className="container-edge py-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">{eyebrow}</div>
          <h1 className="mt-3 font-serif text-6xl md:text-8xl leading-[0.9] tracking-tight">
            <span className="italic text-[#a465a8]">{title}.</span>
          </h1>
          <p className="mt-7 text-lg text-neutral-700 max-w-md leading-relaxed">
            {subtitle || "We're crafting something beautiful. Check back soon — or follow our journey on Instagram."}
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/" className="inline-flex items-center justify-center bg-[#eb5381] hover:bg-[#d64570] text-white px-9 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors">
              Back Home
            </Link>
            <Link to="/artists" className="inline-flex items-center justify-center border border-black hover:bg-black hover:text-white px-9 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors">
              Discover Artists
            </Link>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] bg-[#ffefd1] img-zoom">
            <img src={img} alt="Editorial" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
}
